import React, { useEffect, useState, useContext } from "react";
import "../../../assests/css/students/Courses.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AppContext } from "../../../context/Appcontext";
import { Spinner } from "react-bootstrap";

const Courses = () => {
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFiles } = useContext(AppContext);

  const [programmes, setProgrammes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProgrammes();
    // eslint-disable-next-line
  }, []);

  const fetchProgrammes = async () => {
    try {
      setLoading(true);

      console.log("BASE URL:", baseUrl);

      if (!baseUrl) {
        console.error("baseUrl is undefined!");
        setProgrammes([]);
        setLoading(false);
        return;
      }

      const res = await axios.get(
        `${baseUrl}/admin/programme/viewAllProgramme`
      );

      console.log("API RESPONSE:", res.data);

      const data =
        res.data?.programmes ||
        res.data?.data ||
        res.data?.result ||
        [];

      if (Array.isArray(data)) {
        setProgrammes(data);
      } else {
        setProgrammes([]);
      }

      setLoading(false);
    } catch (error) {
      console.error("API ERROR:", error);
      setProgrammes([]);
      setLoading(false);
    }
  };

  const getImage = (img) => {
    if (!img) return "/placeholder.png";

    if (img.startsWith("http")) return img;

    return `${baseUrlForFiles}/${img}`;
  };

  return (
    <section className="courses">
      <div className="courses__header">
        <h1 className="courses__title">Our Programmes</h1>
        <p className="courses__subtitle">
          Explore all available programmes
        </p>
      </div>

      {/* 🔥 LOADING SPINNER */}
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "300px",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <Spinner animation="border" role="status" />
          <p style={{ marginTop: "10px", fontWeight: "500" }}>
            Loading Programmes...
          </p>
        </div>
      ) : programmes.length === 0 ? (
        <div className="courses__empty">
          No programmes found.
        </div>
      ) : (
        <div className="courses__grid">
          {programmes.map((program) => (
            <article key={program.id} className="courses__card">
              
              <img
                src={getImage(program.image)}
                alt={program.progName || "Programme"}
                className="courses__card-img"
              />

              <div className="courses__card-body">
                <h3>{program.progName}</h3>
                <p>{program.progCode}</p>
                <p>{program.progDegree}</p>
                <p>{program.progDuration}</p>

                {/* <button
                  type="button"
                  onClick={() =>
                    navigate(`/courses/${program.id}`)
                  }
                >
                  View Details →
                </button> */}
              </div>
            </article>
          ))}
        </div>
      )}
    </section>
  );
};

export default Courses;